import { useParams } from "react-router-dom";
import SessionInfoPage from "../components/session-info";
import { useGetSessionByIdQuery } from "../session.service";

const ShowSession = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isSuccess } = useGetSessionByIdQuery(id!, { skip: !id });
  return isSuccess ? <SessionInfoPage session={data.session} users={data.users} /> : null;
};

export default ShowSession;
